export const PI_PATH_PREFIX = '/product-intelligence';

const LOCAL_API = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i;

export const isLocalApi = (apiBase) => typeof apiBase === 'string' && LOCAL_API.test(apiBase);

export const piAvailable = (isProduction, apiBase) => isProduction === true || isLocalApi(apiBase);

export const isPiPath = (path) => typeof path === 'string' && path.toLowerCase().indexOf(PI_PATH_PREFIX) === 0;

export const blockedOutsideProduction = (path, available) => available !== true && isPiPath(path);



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piAvailability.js